// extracted by mini-css-extract-plugin
module.exports = {"container":"CenteredSpinner--styles-module_container-Il9OV"};